import React, { useState } from "react";
import "../Home/Home.css";

const ITEMS_PER_VIEW = 3;

const TestimonialVideoPreview = ({
    previewService,
    setShowPreviewTestimonialVideo
}) => {

    const [startIndex, setStartIndex] = useState(0);

    if (!previewService || !previewService.videoTestimonials?.length) {
        return null;
    }

    const { videoTestimonials } = previewService;

    const handleNext = () => {
        if (startIndex + ITEMS_PER_VIEW < videoTestimonials.length) {
            setStartIndex(startIndex + ITEMS_PER_VIEW);
        }
    };

    const handlePrev = () => {
        if (startIndex - ITEMS_PER_VIEW >= 0) {
            setStartIndex(startIndex - ITEMS_PER_VIEW);
        }
    };

    const visibleVideos = videoTestimonials.slice(
        startIndex,
        startIndex + ITEMS_PER_VIEW
    );

    return (
        <div
            className="tv-overlay"
            onClick={() => setShowPreviewTestimonialVideo(false)}
        >
            <div className="tv-modal" onClick={(e) => e.stopPropagation()}>

                {/* CLOSE */}
                <button
                    className="tv-close"
                    onClick={() => setShowPreviewTestimonialVideo(false)}
                >
                    ✕
                </button>

                <div className="tv-carousel">

                    {/* LEFT */}
                    <button
                        className="tv-arrow left"
                        onClick={handlePrev}
                        disabled={startIndex === 0}
                    >
                        ‹
                    </button>

                    {/* VIDEOS ONLY */}
                    <div className="tv-cards">
                        {visibleVideos.map((item) => (
                            <div className="tv-card" key={item.videotestimonial_id}>
                                <video controls>
                                    <source
                                        src={item.videos?.trim()}
                                        type="video/mp4"
                                    />
                                </video>

                                <h3>{item.name}</h3>
                                <p>{item.professional}</p>

                                <span className="quote">❝</span>
                            </div>
                        ))}
                    </div>

                    {/* RIGHT */}
                    <button
                        className="tv-arrow right"
                        onClick={handleNext}
                        disabled={
                            startIndex + ITEMS_PER_VIEW >=
                            videoTestimonials.length
                        }
                    >
                        ›
                    </button>

                </div>
            </div>
        </div>
    );
};

export default TestimonialVideoPreview;
